/**
 * @generated SignedSource<<681771f6785809ce05e6b98fd428e543>>
 * @relayHash 0d63b7767d20e0fe07b77f6a9b75b657
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 15f8fb5c1ac9cee3e5b2ed474f580b517d4e72506dcd62b730bc9bb5def9f479

import type { ConcreteRequest } from 'relay-runtime';
export type InvokeExtensionInput = {
  async?: boolean | null | undefined;
  contextIds: ReadonlyArray<string>;
  entryPoint?: string | null | undefined;
  extensionDetails?: ExtensionDetailsInput | null | undefined;
  extensionId?: string | null | undefined;
  oAuthScopes?: ReadonlyArray<string> | null | undefined;
  payload: AGG$JSON;
  productEventScopes?: ReadonlyArray<string> | null | undefined;
};
export type ExtensionDetailsInput = {
  definitionId: string;
  extensionKey: string;
};
export type useInvokeExtensionRelayMutation$variables = {
  input: InvokeExtensionInput;
};
export type useInvokeExtensionRelayMutation$data = {
  readonly invokeExtension: {
    readonly contextToken: {
      readonly expiresAt: string;
      readonly jwt: string;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly fields?: {
          readonly authInfoUrl: string | null | undefined;
        } | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly response: {
      readonly body: AGG$JSON;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useInvokeExtensionRelayMutation = {
  response: useInvokeExtensionRelayMutation$data;
  variables: useInvokeExtensionRelayMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "InvocationResponsePayload",
  "kind": "LinkedField",
  "name": "response",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "body"
    }
  ]
},
v4 = {
  "concreteType": "ForgeContextToken",
  "kind": "LinkedField",
  "name": "contextToken",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "jwt"
    },
    {
      "kind": "ScalarField",
      "name": "expiresAt"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "message"
},
v6 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v7 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "InvokeExtensionPayloadErrorExtensionFields",
      "kind": "LinkedField",
      "name": "fields",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "authInfoUrl"
        }
      ]
    }
  ],
  "type": "InvokeExtensionPayloadErrorExtension"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useInvokeExtensionRelayMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "InvokeExtensionResponse",
        "kind": "LinkedField",
        "name": "invokeExtension",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useInvokeExtensionRelayMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "InvokeExtensionResponse",
        "kind": "LinkedField",
        "name": "invokeExtension",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "15f8fb5c1ac9cee3e5b2ed474f580b517d4e72506dcd62b730bc9bb5def9f479",
    "metadata": {},
    "name": "useInvokeExtensionRelayMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c0c91290aaf4ee74a6c4318945b6a1bd";

export default node;
